





























































































import { Component, Prop, Watch } from 'vue-property-decorator';

import MixinDialog from '../../../../plugins/podolib/services/helper/mixins/dialog';

import {
  StepConditions,
  ConditionsPainLocations,
  ConditionsShoesType,
  ConditionsShoesTypeCushioning,
  ConditionsShoesTypeRigidity,
  ConditionsShoesTypeWear,
} from '@/components/analysis/steps/conditions/AnalysisStepConditions';
import { TForm } from '@/plugins/podolib/lib/types';
import { Severity } from '@sentry/types';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';

type TFields = {
  rigidity: {
    value: ConditionsShoesType['rigidity'];
  };
  cushioning: {
    value: ConditionsShoesType['cushioning'];
  };
  wear: {
    value: ConditionsShoesType['wear'];
  };
};

@Component
export default class AnalysisStepConditionsShoesTypeDialog extends MixinDialog {
  @Prop({ required: true }) private shoes_type!: StepConditions['shoes_type'];
  @Prop({ required: false, default: false }) private editResults!: boolean;
  @Prop({ required: false, default: null }) private acquisitionId!: TEntity<TAcquisition>['_id'];

  mode: 'add' | 'edit' | null = null;

  form: TForm<TFields> = {
    fields: {
      rigidity: {
        value: null!,
      },
      cushioning: {
        value: null!,
      },
      wear: {
        value: null!,
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  get items() {
    let rigidity;
    let cushioning;
    let wear;

    rigidity = this.$pdc.helper!.enumToArrayAndTranslate(ConditionsShoesTypeRigidity, {
      key: 'analysis.steps.conditions.shoes_type.rigidity',
    });
    cushioning = this.$pdc.helper!.enumToArrayAndTranslate(ConditionsShoesTypeCushioning, {
      key: 'analysis.steps.conditions.shoes_type.cushioning',
    });
    wear = this.$pdc.helper!.enumToArrayAndTranslate(ConditionsShoesTypeWear, {
      key: 'analysis.steps.conditions.shoes_type.wear',
    });

    return {
      rigidity,
      cushioning,
      wear,
    };
  }

  _open(mode: 'add' | 'edit') {
    this.mode = mode;

    if (this.mode === 'edit') {
      this.form.fields.rigidity.value = this.shoes_type!.rigidity;
      this.form.fields.cushioning.value = this.shoes_type!.cushioning;
      this.form.fields.wear.value = this.shoes_type!.wear;
    }

    this.open();
  }

  _close() {
    this.mode = null;

    this.close();
  }

  save() {
    switch (this.mode) {
      case 'add':
        return this.createShoesType();
      case 'edit':
        return this.patchShoesType();
    }
  }

  async createShoesType() {
    try {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;

      if (!this.editResults) {
        this.$emit('update:shoes_type', {
          rigidity: this.form.fields.rigidity.value,
          cushioning: this.form.fields.cushioning.value,
          wear: this.form.fields.wear.value,
        });
      } else {
        this.$pdc.repository?.patchRessource({
          ressource: 'acquisitions',
          params: {
            _id: this.acquisitionId,
          },
          data: {
            $set: {
              'conditions.shoes_type': {
                rigidity: this.form.fields.rigidity.value,
                cushioning: this.form.fields.cushioning.value,
                wear: this.form.fields.wear.value,
              },
            },
          },
        });
      }

      this._close();
    } catch (e) {
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
  async patchShoesType() {
    try {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;

      if (!this.editResults) {
        this.$emit('update:shoes_type', {
          rigidity: this.form.fields.rigidity.value,
          cushioning: this.form.fields.cushioning.value,
          wear: this.form.fields.wear.value,
        });
      } else {
        this.$pdc.repository?.patchRessource({
          ressource: 'acquisitions',
          params: {
            _id: this.acquisitionId,
          },
          data: {
            $set: {
              'conditions.shoes_type': {
                rigidity: this.form.fields.rigidity.value,
                cushioning: this.form.fields.cushioning.value,
                wear: this.form.fields.wear.value,
              },
            },
          },
        });
      }

      this._close();
    } catch (e) {
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
}
